module.exports = __webpack_public_path__ + "d970c8651bd7de69cc96b6b41338fa9c.pdf";